import React from 'react';
import propTypes from 'prop-types';
import format from 'react-format-props';
import { compose } from 'redux';
import { GENERIC_MESSAGE_PLACEHOLDER } from '../../../shared/constants';
import * as I18n from '../../lib/hoc';
import { appTranslate } from '../../../i18n';
import { DEFAULT_VALUE } from '../../enums/consts';
import { getContentForItem } from './customTemplates';
import './style.scss';

export function ItemContent({ unsafeString, content, username, displayName, subType, msgParams, i18n }) {
    const diplayNameTitle = displayName || username;
    if (unsafeString) {
        const messageContent =
            unsafeString === GENERIC_MESSAGE_PLACEHOLDER
                ? appTranslate('notifications_drawer.generic_message')
                : unsafeString;

        return (
            <p className="content">
                <div className="content-container">
                    <strong className="display-name">{diplayNameTitle}</strong>
                    {displayName ? <span className="username">@{username}</span> : ''}
                </div>
                {messageContent}
            </p>
        );
    }

    if (content) {
        if (content === DEFAULT_VALUE) {
            const item = { subType, msgParams };
            const content = getContentForItem(item, i18n);
            return <p className="content" dangerouslySetInnerHTML={{ __html: content }} />;
        }

        return <p className="content" dangerouslySetInnerHTML={{ __html: content }} />;
    }

    return null;
}

ItemContent.propTypes = {
    content: propTypes.string,
    unsafeString: propTypes.string,
    username: propTypes.string,
    displayName: propTypes.string,
    subType: propTypes.string,
    msgParams: propTypes.object,
    i18n: propTypes.shape({
        t: propTypes.func,
    }),
};

export default compose(
    I18n.connect,
    format(({ item, i18n }) => ({
        unsafeString: item.userMessage,
        content: item.content,
        username: item.username,
        displayName: item.display_name || item.senderDisplayName,
        subType: item.subType,
        msgParams: item.msg_params,
        i18n,
    }))
)(ItemContent);
